export const FORM_LOGIN_DEALER = () => {
  return [
    {
      name: 'storeId',
      label: 'ชื่อร้าน',
      type: 'INPUT_QR',
      rules: {
        required: true,
      },
    },
    {
      name: 'storeName',
      label: 'สาขา',
      type: 'INPUT',
      disabled: true,
    },
    {
      name: 'phoneNumber',
      label: 'เบอร์โทรศัพท์',
      type: 'INPUT',
      disabled: true,
    },
    {
      name: 'password',
      label: 'รหัสผ่าน',
      type: 'INPUT_PASSWORD',
      placeholder: 'กรอกรหัสผ่าน',
      span: 24,
      rules: {
        required: true,
      },
    },
  ];
};

export const FORM_SHOW_LOGGED_IN = () => {
  return [
    {
      name: 'storeMasterName',
      label: 'ชื่อร้าน',
      type: 'INPUT',
      disabled: true,
    },
    {
      name: 'storeName',
      label: 'สาขา',
      type: 'INPUT',
      disabled: true,
    },
    {
      name: 'telephone',
      label: 'เบอร์โทรศัพท์',
      type: 'INPUT',
      disabled: true,
    },
  ];
};
